<form [formGroup] = "userEmail" (ngSubmit)= "submit()">
    <input [class.is-invalid] = "userEmail.get('email').invalid && userEmail.get('email').touched" formControlName="email" type="email" class="form-control" placeholder="zombie@horde.com"   />
    <button *ngIf="!primEmail.invalid" type="submit"> Keep me informed</button>
    <small *ngIf="primEmail.invalid" class="text-danger">Please enter email address</small>
</form>
